// @flow
import React from 'react';

import Tier from './Tier/Tier';

type Props = {
  tiers: SearchViewModelTiers
};

export default ({ tiers }: Props) => (
  <div>
    {tiers.map(
      (tier, tierIndex) =>
        tier.jobs.length > 0 && (
          <div key={tierIndex}>
            <Tier
              tierNumber={tierIndex + 1}
              header={tier.header}
              jobs={tier.jobs}
            />
          </div>
        )
    )}
  </div>
);
